import ProductDetailHeading from './ProductDetailHeading';

const Disclaimer = () => {
    return (
        <div className="u-marginBmd">
            <ProductDetailHeading>Övrig information</ProductDetailHeading>
            <p className="u-marginTz">
                Vi på Coop gör vårt bästa för att alltid ge Dig rätt produktinformation. Över tid
                kan det ske mindre förändringar av innehållet. Vi vill därför vänligen påminna Dig
                om att före användning kontrollera produktinformationen på produktens förpackning.
                Det här är så klart särskilt viktigt om Du av någon anledning vill undvika vissa
                ingredienser eller ämnen.
            </p>
        </div>
    );
};

export default Disclaimer;
